import { Typography } from "@mui/material";

interface OwnsProps {
  msg: string;
  className?: string;
}

const CommonNoRecordMsg = ({ msg, className }: OwnsProps) => {
  return (
    <Typography variant="subtitle2" className={className} mt={1}>
      {msg}
    </Typography>
  );
};
export default CommonNoRecordMsg;
